import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  HeroPanel,
  DetailTilesContainer,
  EnvironmentTitle,
  BannerTilesGroup,
  BannerStatusTile,
  getOpenRepoCashAndNotionalAmounts,
  BannerCurrencyTotalTilesContainer
} from 'view/shared/heroPanel'
import { WindowActions } from 'epics/windowEpic'
import { Translation, Locale } from 'locale'
import { DealDetail } from 'api'
import { userPreferenceSelector } from 'selectors/userPreferenceSelectors'
import { BannerCurrencyTotalTile } from 'view/shared/heroPanel/BannerCurrencyTotalTile'

interface StructuredHeroPanelProps {
  dealDetails: DealDetail[]
}

export const StructuredHeroPanel: React.FC<StructuredHeroPanelProps> = ({ dealDetails }) => {
  const dispatch = useDispatch()
  const userPreference = useSelector(userPreferenceSelector)
  const cashAndNotionalAmounts = getOpenRepoCashAndNotionalAmounts(dealDetails)

  return (
    <HeroPanel onTearout={() => dispatch(WindowActions.tearoutGrid('/quote/tearout/structured'))}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'StructuredHeroPanel-EnvironmentTitle'}>
          {Locale.translate(Translation.TC_HERO_STRUCTURED)}
        </EnvironmentTitle>
        <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_STATUS)}>
          <BannerStatusTile title={Locale.translate(Translation.TC_SECTION_STRUCTURED)} label={dealDetails.length} />
        </BannerTilesGroup>
      </DetailTilesContainer>

      <BannerCurrencyTotalTilesContainer>
        {cashAndNotionalAmounts.map((cashAndNotionalAmount, idx) => (
          <BannerCurrencyTotalTile
            key={`${cashAndNotionalAmount.currency}-${idx}`}
            cashAndNotionalAmount={cashAndNotionalAmount}
            userPreference={userPreference}
          />
        ))}
      </BannerCurrencyTotalTilesContainer>
    </HeroPanel>
  )
}
